<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Contents</p>
<p class="toc"><a href="#/Acknowledgement">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Part1">Part I: Meet Me at the Fair, and We’ll Have a Bite to Eat</a></p>
<p class="toc"><span href="#/Part2" title="Link target outside of Sample">Part II: Really Golden Oldies</span></p>
<p class="toc"><span href="#/Part3" title="Link target outside of Sample">Part III: Still Open for Business</span></p>
<p class="toc"><span href="#/Part4" title="Link target outside of Sample">Part IV: In Those Kitchens</span></p>
<p class="toc1"><span href="#/Suggested" title="Link target outside of Sample">Suggested Reading</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?483839fb